export const UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT';
export const UPDATE_ENROLLED_COURSE = 'UPDATE_ENROLLED_COURSE';
export const SET_COURSES_ENROLLED = 'SET_COURSES_ENROLLED';
export const SET_CATALOGUE = 'SET_CATALOGUE';
export const UPDATE_CATALOGUE_DATA = 'UPDATE_CATALOGUE_DATA';
export const UPDATE_CATALOGUE_PAGINATION = 'UPDATE_CATALOGUE_PAGINATION';
export const UPDATE_COURSE_RESULTS = 'UPDATE_COURSE_RESULTS';
export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
export const UPDATE_COMPLETED_COURSES = 'UPDATE_COMPLETED_COURSES';